module.exports = __webpack_public_path__ + "img/coming-soon-bg.bc1fb2a6.jpg";